<template lang="html">
  <div class="oktatok-component">
    <v-container>
      <v-row  justify="center">
        <v-radio-group v-model="state" row>
          <v-radio label="Aktív" color="#FF9800" value="false"></v-radio>
          <v-radio label="Archív" color="#FF9800" value="true" ></v-radio>
          <v-radio label="Mind" color="#FF9800" value="true, false" ></v-radio>
        </v-radio-group>
      </v-row>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Keresés"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="teacher_headers"
        :items="teachers"
        :search="search"
        :mobile-breakpoint='NaN'
        disable-pagination
        hide-default-footer
      >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, index) in items">
            <td style='min-width: 100px'>{{ index + 1 }}</td>
            <td style='min-width: 180px'>{{ item.name }}</td>
            <td style='min-width: 150px'>{{ item.phone_number_mobile }}</td>
            <td>{{ item.jtip }}</td>
            <td style='min-width: 110px'>{{ item.tanp }}</td>
            <td style='min-width: 110px'>{{ item.teacher_code }}</td>
            <td>
                  <v-btn rounded outlined color="primary" @click="selected_teacher = item.teacher_id, TeacherDetails()">
                    adatok
                    <v-icon right dark>assignment</v-icon>
                  </v-btn>
            </td>
            <td>
                  <v-btn rounded outlined color="primary" @click="selected_teacher = item.teacher_id, Students()">
                    Tanulók
                    <v-icon right dark>account_circle</v-icon>
                  </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    </v-card>
    </v-container>

    <v-dialog
      v-model="students_dialog"
      width="900"
      scrollable
    >
      <v-card>

        <v-toolbar dark color="grey lighten-2">
        <v-toolbar-title class="black--text">Tanulók listája</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="students_dialog = false">
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
        </v-toolbar>
        <v-row  justify="center">
          <v-radio-group v-model="students_state" row>
            <v-radio label="Aktív" color="#FF9800" value="false"></v-radio>
            <v-radio label="Archív" color="#FF9800" value="true" ></v-radio>
            <v-radio label="Mind" color="#FF9800" value="true, false" ></v-radio>
          </v-radio-group>
        </v-row>
        <v-card-text>
          <v-data-table
            :headers="students_headers"
            :items="students"
            :items-per-page="20"
            hide-default-header
          >
          <template
            v-slot:header="{ props: { headers, mobile } }"
          >
            <thead v-if="!mobile">
              <tr>
                <th class="text-left">Név</th>
                <th class="text-left">Kategória</th>
                <th class="text-left">Kezdés</th>
                <th class="text-left">Befejezés</th>
                <th class="text-left">Megejgyzés</th>
              </tr>
            </thead>
          </template>
          </v-data-table>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog
      v-model="teacher_dialog"
      width="900"
      scrollable
      persistent
    >
      <v-card>

        <v-toolbar dark color="grey lighten-2">
        <v-toolbar-title class="black--text">Oktatói adatok</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="teacher_dialog = false">
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
        <v-container>
        <v-form
          ref="oktato_form"
          v-model="valid"
        >
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="teacher_name"
              label="Név"
              outlined
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="teacher_code"
              label="Azonosító"
              outlined
              :rules="teacher_az_rule"
              v-mask="'#####'"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="teacher_categories"
              :items="categories"
              item-text="soap_course_type_code"
              item-value="course_type_key"
              multiple
              outlined
              label="Kategóriák"
              :rules="[rules.required]"
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="12">
             <v-autocomplete
                    v-model="kav_okato"
                    :items="kav_oktatok"
                    item-text="Megnevezes"
                    item-value="Id"
                    label="KAV oktatók"
                    outlined
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="teacher_mail"
              label="E-mail"
              outlined
              :rules="[rules.email]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="teacher_phone"
              label="Telefonszám"
              outlined
              :rules="phone_rules"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="teacher_place"
              label="Találkozási hely"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="is_public">
            <v-combobox
              v-model="palya_value"
              :items="gyak_helyszin"
              label="Publikus helyszín"
              :rules="[rules.required]"
              outlined
              multiple
              chips
            ></v-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="3">
            <v-checkbox
              v-model="kata"
              label="Kisadózó"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox
              v-model="is_public"
              label="Publikus"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3" v-if="admin">
            <v-checkbox
              v-model="tiltott"
              label="Tiltott"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox
              v-model="teacher_archived"
              label="Archív"
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="3">
            <v-checkbox
              :disabled="!admin"
              v-model="is_sticker"
              label="Matricás"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox
              :disabled="!admin"
              v-model="is_unique"
              label="Egyedi óradíj"
            ></v-checkbox>
          </v-col>
          </v-row>
        
        <div class="subtitle-1">Járművek</div>
        <v-divider></v-divider><br>

        <v-row>
          <v-col cols="12" md="5">
            <v-combobox
              v-model="teacher_car"
              :items="teacher_cars"
              label="Autó típus"
              item-value="id"
              item-text="tipus"
              outlined
              @change="handleCarChange"
            ></v-combobox>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="teacher_frsz"
              label="Rendszám"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-checkbox
              v-model="car_sticker"
              label="Matrica"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="2">
            <v-checkbox
              v-model="car_auto"
              label="Automata"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="selected_teacher">
          <v-col cols="12" md="4">
            <v-btn
            outlined
            color="green"
            :disabled="!teacher_car || !teacher_frsz || teacher_car['id'] || teacher_car == ''"
            @click="carSave()"
            :loading="car_loader"
          >
            új Autó Rögzítés
          </v-btn>
          </v-col>
          <v-col cols="6" md="4">
            <v-btn
            outlined
            color="red"
            :disabled="!teacher_car['id']"
            @click="carMod()"
          >
            Módosítás
          </v-btn>
          </v-col>
          <v-col cols="6" md="4">
            <v-btn
            outlined
            color="red"
            :disabled="!teacher_car['id']"
            @click="carArchive()"
          >
            Törlés
          </v-btn>
          </v-col>
        </v-row>
        <br>
        <div class="subtitle-1">Lakcím (székhely) adatok</div>
        <v-divider></v-divider><br>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="teacher_irsz"
              label="Irányítószám"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="teacher_city"
              label="Település"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="teacher_street"
              label="Utca"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="teacher_tax_number"
              label="Adószám"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>

        <div class="subtitle-1">Megbízási szerződés adatok</div>
        <v-divider></v-divider><br>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="teacher_birth_name"
              label="Születéskori név"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="teacher_mother_name"
              label="Anyja neve"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="teacher_birth_place"
              label="Születési hely"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="teacher_birthdate"
              v-mask="'####-##-##'"
              hint="formátum: éééé-hh-nn"
              label="Születési idő"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="teacher_tb"
              label="TAJ szám"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="nyugdij"
              label="Nyugdíjas törzsszám"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="bankszamla"
              label="Bankszámlaszám"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>

        </v-form>
        </v-container>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            outlined
            color="green"
            @click="portalRegTeacher()"
            :disabled="!selected_teacher || !teacher_mail || !valid"
          >
            Portál regisztráció
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="red"
            @click="saveTeacherDetails"
            :disabled="!valid"
          >
            Mentés
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <v-dialog
      v-model="elojegyzes_dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="green"
        >
          <v-toolbar-title>Gyakorlati előjegyzés</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="elojegyzes_dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-row  justify="center">
          <v-col cols="12" md="4">
          <v-radio-group v-model="prereg_state" row>
            <v-radio label="Aktív" color="#FF9800" value="false"></v-radio>
            <v-radio label="Archív" color="#FF9800" value="true"></v-radio>
            <v-radio label="Mind" color="#FF9800" value="all"></v-radio>
          </v-radio-group>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox
              v-model="kapott_oktatot"
              label="Kapott már oktatót"
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-container>
        <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="prereg_search"
            append-icon="mdi-magnify"
            label="Keresés"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="selected_helyszin"
            :items="okt_helyszinek"
            item-value="value"
            item-text="text"
            label="Helyszín"
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" md="2" class="mt-2">
          <v-btn
            outlined
            color="red"
            @click="prereg_state = 'false', prereg_search = '', selected_helyszin = null, kapott_oktatot = false"
          >
            Szűrők törlése
          </v-btn>
        </v-col>
        </v-row>
        </v-container>

        <v-card-text>
          <v-data-table
            :headers="prereg_headers"
            :items="prereg_list"
            :items-per-page="20"
            :search="prereg_search"
            sort-by="regido"
            sort-desc
            @click:row="getPregStud($event.id)"
          >
          </v-data-table>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog
      v-model="preg_student_dialog"
      width="900"
      scrollable
    >
      <v-card>

        <v-toolbar dark color="grey lighten-2">
        <v-toolbar-title class="black--text">Tanuló adatok</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="preg_student_dialog = false">
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
        <v-container>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="student_name"
              label="Név"
              outlined
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="student_bd"
              label="Születési idő"
              outlined
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="student_email"
              label="E-mail"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="student_phone"
              label="Telefonszám"
              outlined
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="student_reg_place"
              label="Beiratkozás helye"
              outlined
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="student_helyszin"
              :items="okt_helyszinek"
              item-value="value"
              item-text="text"
              label="Oktatási helyszín"
              outlined
              multiple
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="student_oktato"
              :items="preg_oktatok"
              item-value="id"
              item-text="nev"
              label="Ajánlott oktató"
              outlined
              append-outer-icon="delete"
              @click:append-outer="student_oktato = null"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="portal_comment"
              outlined
              label="Tanulói Megjegyzés"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="student_comment"
              outlined
              name="input-7-4"
              label="Megjegyzés"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="send_email_text"
              outlined
              name="input-7-4"
              label="Üzenet küldése"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-btn
              outlined
              rounded
              color="primary"
              @click="pregMessage()"
            >
              Küldés
              <v-icon
                right
                dark
              >
                send
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-checkbox
              v-model="student_archived"
              label="Archív"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="prereg_date"
              label="Regisztráció ideje"
              outlined
              v-mask="'####-##-##'"
            ></v-text-field>
          </v-col>
        </v-row>
        </v-container>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            outlined
            color="primary"
            @click="goToStudent()"
          >
            Ugrás a tanulóhoz
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="red"
            @click="getBillClient()"
          >
            Mentés
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <v-btn
      @click="preregList()"
      style="top: 80px;"
      fixed
      fab
      top
      right
      color="green"
    >
    <v-icon color="white">assignment</v-icon>
    </v-btn>

    <v-btn
      @click="CreateTeacher"
      fixed
      dark
      fab
      bottom
      left
      color="white"
    >
    <img src="https://www.gstatic.com/images/icons/material/colored_icons/1x/create_32dp.png">
    </v-btn>

    <v-snackbar
      v-model="response_snackbar"
    >
      {{ response_text }}
        <v-btn
          color="pink"
          text
          @click="response_snackbar = false"
        >
          bezár
        </v-btn>
    </v-snackbar>

    <v-snackbar
      v-model="error_snackbar"
      color="error"
    >
      {{ error_message }}
        <v-btn
          color="white"
          text
          @click="error_snackbar = false"
        >
          bezár
        </v-btn>
    </v-snackbar>

    <v-dialog
      v-model="error_dialog"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 red lighten-2">
          Figyelem!
        </v-card-title>

        <v-card-text>
          <br>
          {{ error_message }}
          <br><br>
          Biztosan hozzárendeli a tanulóhoz az oktatót?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            @click="error_dialog = false"
          >
            Mégsem
          </v-btn>
                    <v-btn
            color="green"
            text
            @click="savePregStud(), error_dialog = false"
          >
            Igen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import router from '../router'

  export default {
    data () {
      return {
        teacher_headers: [
          { text: 'Sorszám'},
          { text: 'Név', value: 'name' },
          { text: 'Telefon', value: 'phone_number_mobile' },
          { text: 'Jármű', value: 'jtip' },
          { text: 'Helyszín', value: 'tanp' },
          { text: 'Azonosító', value: 'teacher_code' },
          { text: ''},
          { text: ''},
        ],
        students_headers: [
          { text: 'Név', value: 'full_name' },
          { text: 'Kategória', value: 'contract_name' },
          { text: 'Kezdés', value: 'start_date' },
          { text: 'Befejezés', value: 'end_date' },
          { text: 'Megejgyzés', value: 'description' },
        ],
        prereg_headers: [
          { text: 'Sorszám', value: 'sorszam' },
          { text: 'Regisztráció ideje', value: 'regido', width: 150 },
          { text: 'Beiratkozás ideje', value: 'beiratkozas', width: 150 },
          { text: 'Név', value: 'nev', width: 180 },
          { text: 'Telefon', value: 'telefon', width: 150 },
          { text: 'Oktatási helyszín', value: 'helyszin' },
          { text: 'Iroda', value: 'iroda', width: 120 },
          { text: 'Oktató', value: 'oktato_nev', width: 120 },
        ],
        teachers: [],
        students: [],
        search: '',
        state: 'false',
        students_dialog: false,
        students_state: 'false',
        selected_teacher: '',
        teacher_details: '',
        teacher_dialog: false,
        teacher_name: '',
        teacher_birth_name: '',
        teacher_mother_name: '',
        teacher_birthdate: '',
        teacher_birth_place: '',
        teacher_tb: '',
        nyugdij: '',
        bankszamla: '',
        teacher_phone: '',
        teacher_car: '',
        teacher_frsz: '',
        teacher_place: [],
        teacher_code: '',
        teacher_mail: '',
        is_public: '',
        teacher_tax_number: '',
        teacher_irsz: '',
        teacher_city: '',
        teacher_street: '',
        teacher_archived: '',
        response_snackbar: false,
        error_snackbar: false,
        error_dialog: false,
        error_message: '',
        response_text: '',
        categories: [],
        teacher_categories: [],
        rules: {
            required: value => !!value || 'Kötelező mező!',
            email: value => {
            if(value != '') {
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              return pattern.test(value) || 'Hibás e-mail cím!'
            }
          },
        },
        teacher_az_rule: [
              v => /\d{5}/.test(v) || 'Hibás azonosító!',
              v => !!v || 'Kötelező mező!',
          ],
        phone_rules: [
          value => (!!value && /06\d{8,9}$/.test(value)) || 'Hibás telefonszám formátum! (helyes alak: 067012345678)',
        ],
        valid: true,
        elojegyzes_dialog: false,
        prereg_list: [],
        prereg_state: "false",
        prereg_search: '',
        //okt_helyszinek: [],
        okt_helyszinek: [
          { text: 'Virágpiac', value: 'Virágpiac'},
          { text: 'Határ út', value: 'Határ út'},
          { text: 'Írottkő', value: 'Írottkő'},
          { text: 'Kőbánya-Kispest', value: 'Kőbánya-Kispest'},
          { text: 'Duna Pláza', value: 'Duna Pláza'},
          { text: 'Szigetszentmiklós', value: 'Szigetszentmiklós'},
          { text: 'Csepel', value: 'Csepel'},
          { text: 'Berda József', value: 'Berda József'},
        ],
        selected_helyszin: '',
        preg_student_dialog: false,
        preg_student: '',
        student_name: '',
        student_bd: '',
        student_email: '',
        student_phone: '',
        student_helyszin: [],
        student_oktato: '',
        student_comment: '',
        portal_comment: '',
        preg_oktatok: [],
        preg_contract_id: '',
        preg_customer_id: '',
        preg_tanulo_id: '',
        student_archived: '',
        kapott_oktatot: false,
        send_email_text: '',
        prereg_date: '',
        student_reg_place: '',
        palya_value: [],
        kata: '',
        tiltott: '',
        kav_oktatok: [],
        kav_okato: '',
        is_sticker: '',
        is_unique: '',
        teacher_cars: [],
        car_sticker: false,
        car_auto: false,
        car_loader: false,
      }
    },
    methods: {
      Teachers: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/teacher_list', {
          token: this.token,
          archived: this.state
        }).then((response) => {
          this.preloader = false
          this.teachers = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
      getKAVTeachers: async function() {
        this.kav_oktatok = []
        await this.gettoken()
        this.$http.post('/kokeny/oktatok_kav', {
          token: this.token
        }).then((response) => {
          this.kav_oktatok = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
      TeacherDetails: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/teacher_adatok_250606', {
          token: this.token,
          teacher_id: this.selected_teacher
        }).then((response) => {
          this.preloader = false
          this.teacher_details = response.data
          this.teacher_cars = response.data['cars']
          this.teacher_name = response.data['teacher_adatok'][0]['name']
          this.teacher_phone = response.data['teacher_adatok'][0]['phone_number_mobile']
          if (response.data['cars'] && response.data['cars'].length > 0) {
            this.teacher_car = { id: response.data['cars'][0]['id'], tipus: response.data['cars'][0]['tipus'], rendszam: response.data['cars'][0]['rendszam'] };  
            this.teacher_frsz = response.data['cars'][0]['rendszam']
            this.car_auto = response.data['cars'][0]['automata']
            this.car_sticker = response.data['cars'][0]['matrica']
          } else {
            this.teacher_car = [];
            this.teacher_frsz = null
            this.car_auto = false
            this.car_sticker = false
          }
          this.teacher_place = response.data['teacher_adatok'][0]['tanp']
          this.teacher_code = response.data['teacher_adatok'][0]['teacher_code']
          this.teacher_mail = response.data['teacher_adatok'][0]['email']
          this.is_public = response.data['teacher_adatok'][0]['is_public']
          this.kata = response.data['teacher_adatok'][0]['kata']
          this.tiltott = response.data['teacher_adatok'][0]['tiltott']
          this.teacher_tax_number = response.data['teacher_adatok'][0]['tax_number']
          this.teacher_irsz = response.data['teacher_adatok'][0]['zip']
          this.teacher_city = response.data['teacher_adatok'][0]['city']
          this.teacher_street = response.data['teacher_adatok'][0]['street']
          this.teacher_archived = response.data['teacher_adatok'][0]['archived']
          this.teacher_categories = response.data['teacher_adatok'][0]['categories']
          this.teacher_birth_name = response.data['teacher_adatok'][0]['teacher_birth_name']
          this.teacher_mother_name = response.data['teacher_adatok'][0]['teacher_mother_name']
          this.teacher_birthdate = response.data['teacher_adatok'][0]['birthdate']
          this.teacher_birth_place = response.data['teacher_adatok'][0]['teacher_birth_place']
          this.teacher_tb = response.data['teacher_adatok'][0]['teacher_tb']
          this.nyugdij = response.data['teacher_adatok'][0]['nyugdij']
          this.bankszamla = response.data['teacher_adatok'][0]['bankszamla']
          this.palya_value = response.data['teacher_adatok'][0]['palya']
          this.kav_okato = response.data['teacher_adatok'][0]['kokeny_id']
          this.is_sticker = response.data['teacher_adatok'][0]['is_sticker']
          this.is_unique = response.data['teacher_adatok'][0]['is_unique']
          this.teacher_dialog = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      saveTeacherDetails: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/teacher_adatok_save_250610', {
          token: this.token,
          teacher_id: this.selected_teacher,
          teacher_name: this.teacher_name,
          teacher_phone: this.teacher_phone,
          teacher_car: this.teacher_car,
          teacher_frsz: this.teacher_frsz,
          teacher_place: this.teacher_place,
          teacher_code: this.teacher_code,
          teacher_mail: this.teacher_mail,
          is_public: this.is_public,
          teacher_tax_number: this.teacher_tax_number,
          teacher_irsz: this.teacher_irsz,
          teacher_city: this.teacher_city,
          teacher_street: this.teacher_street,
          teacher_categories: this.teacher_categories,
          archived: this.teacher_archived,
          teacher_birth_name: this.teacher_birth_name,
          teacher_mother_name: this.teacher_mother_name,
          teacher_birthdate: this.teacher_birthdate,
          teacher_birth_place: this.teacher_birth_place,
          teacher_tb: this.teacher_tb,
          nyugdij: this.nyugdij,
          bankszamla: this.bankszamla,
          palya: this.palya_value,
          kata: this.kata,
          tiltott: this.tiltott,
          kav_okato: this.kav_okato,
          is_sticker: this.is_sticker,
          is_unique: this.is_unique,
          teacher_car: this.teacher_car,
          teacher_frsz: this.teacher_frsz,
          car_sticker: this.car_sticker,
          car_auto: this.car_auto
        }).then((response) => {
          this.response_text = response.data['message']
          this.selected_teacher = response.data['id']
          this.response_snackbar = true
          this.preloader = false
          this.TeacherDetails()
          this.Teachers()
          this.getPalces()
        }, (error) => {
          this.error_text = error.data
        })
      },
      CreateTeacher() {
        this.teacher_dialog = true
        this.selected_teacher = null
        this.teacher_name = null
        this.teacher_phone = null
        this.teacher_car = null
        this.teacher_frsz = null
        this.teacher_place = null
        this.teacher_code = null
        this.teacher_mail = null
        this.is_public = null
        this.teacher_tax_number = null
        this.teacher_irsz = null
        this.teacher_city = null
        this.teacher_street = null
        this.teacher_archived = null
        this.teacher_categories = null
        this.palya_value = null
        this.teacher_birth_name = null
        this.teacher_mother_name = null
        this.teacher_birthdate = null
        this.kav_okato = -100
        this.teacher_birth_place = null
        this.teacher_tb = null
        this.nyugdij = null
        this.bankszamla = null
        this.palya_value = null
        this.kata = null
        this.tiltott = null
        this.is_sticker = null
        this.is_unique = null
        this.car_sticker = null
        this.car_auto = null
        this.teacher_cars = []
        this.resetValidation()
      },
      handleCarChange(value) {
        if (typeof value === 'object' && value !== null) {
          // Kiválasztott egy létező autót
          this.teacher_frsz = value.rendszam;
          this.car_sticker = value.matrica;
          this.car_auto = value.automata;
        } else {
          this.teacher_frsz = '';
          this.car_sticker = false;
          this.car_auto = false;
        }
      },
      portalRegTeacher: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/portalReg', {
          token: this.token,
          teacher_id: this.selected_teacher,
          teacher_mail: this.teacher_mail,
          teacher_name: this.teacher_name
        }).then((response) => {
          this.preloader = false
          this.response_text = response.data;
          this.response_snackbar = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      Students: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/teacher_diakok', {
          token: this.token,
          archived: this.students_state,
          teacher_id: this.selected_teacher
        }).then((response) => {
          this.preloader = false
          this.students = response.data
          this.students_dialog = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      carArchive: async function() {
        const confirmed = window.confirm('Biztosan archiválni szeretnéd ezt az autót?')
        if (!confirmed) {
          return
        }
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/teacher_car_del', {
          token: this.token,
          teacher_car: this.teacher_car
        }).then((response) => {
          this.TeacherDetails();
          this.preloader = false
          this.response_text = response.data;
          this.response_snackbar = true
          console.log(response.data);
        }, (error) => {
          this.error_text = error.data
        })
      },
      carSave: async function() {
        const confirmed = window.confirm('Biztosan rögzíteni szeretnéd az új autót?')
        if (!confirmed) {
          return
        }
        this.car_loader = true
        await this.gettoken()
        this.$http.post('/oktatok/teacher_car_save', {
          token: this.token,
          teacher_id: this.selected_teacher,
          teacher_car: this.teacher_car,
          teacher_frsz: this.teacher_frsz,
          car_sticker: this.car_sticker,
          car_auto: this.car_auto
        }).then((response) => {
          this.TeacherDetails();
          this.car_loader = false
          this.response_text = response.data;
          this.response_snackbar = true
          console.log(response.data);
        }, (error) => {
          this.car_loader = false
          this.error_text = error.data
        })
      },
      carMod: async function() {
        const confirmed = window.confirm('Biztosan módosítani szeretnéd az autót?')
        if (!confirmed) {
          return
        }
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/teacher_car_mod', {
          token: this.token,
          teacher_car: this.teacher_car,
          teacher_frsz: this.teacher_frsz,
          car_sticker: this.car_sticker,
          car_auto: this.car_auto
        }).then((response) => {
          this.TeacherDetails();
          this.preloader = false
          this.response_text = response.data;
          this.response_snackbar = true
          console.log(response.data);
        }, (error) => {
          this.error_text = error.data
        })
      },
      preregList: async function() {
        this.prereg_list = []
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/elojegyzes_lista_20210125', {
          token: this.token,
          prereg_state: this.prereg_state,
          kapott_oktatot: this.kapott_oktatot,
          selected_helyszin: this.selected_helyszin
        }).then((response) => {
          this.preloader = false
          this.prereg_list = response.data
          this.elojegyzes_dialog = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      getCategories: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/category_list', {
          token: this.token
        }).then((response) => {
          this.preloader = false
          this.categories = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
      getOktHelyszin: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/helyszinek', {
          token: this.token
        }).then((response) => {
          this.preloader = false
          this.okt_helyszinek = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
      getPregOktatok: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/preg_oktatok_220801', {
          token: this.token
        }).then((response) => {
          this.preloader = false
          this.preg_oktatok = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
      getPregStud: async function(tanulo_id) {
        this.preg_tanulo_id = tanulo_id
        this.send_email_text = null
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/elojegyzes_tanulo_20210125', {
          token: this.token,
          tanulo_id: tanulo_id
        }).then((response) => {
          this.preg_student_dialog = true
          this.preloader = false
          this.student_name = response.data[1]['nev']
          this.student_bd = response.data[1]['szuletett']
          this.student_email = response.data[1]['email']
          this.student_phone = response.data[1]['telefon']
          this.student_helyszin = response.data[0]['helyszin']
          this.student_oktato = parseInt(response.data[0]['oktato'])
          this.student_comment = response.data[0]['megjegyzes']
          this.portal_comment = response.data[0]['megjegyzes_st']
          this.student_archived = response.data[0]['archiv']
          this.preg_contract_id = response.data[1]['contract_id']
          this.preg_customer_id = response.data[1]['customer_id']
          this.prereg_date = response.data[0]['regido']
          this.student_reg_place = response.data[1]['place_name']
        }, (error) => {
          this.error_text = error.data
        })
      },
      savePregStud: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/update_elojegyzes_tanulo_20210125', {
          token: this.token,
          preg_tanulo_id: this.preg_tanulo_id,
          student_helyszin: this.student_helyszin,
          student_oktato: this.student_oktato,
          student_comment: this.student_comment,
          archiv: this.student_archived,
          prereg_date: this.prereg_date
        }).then((response) => {
          this.preloader = false
          this.response_text = response.data['message']
          this.response_snackbar = true
          this.preregList()
        }, (error) => {
          this.error_text = error.data
        })
      },
      pregMessage: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/prereg_message', {
          token: this.token,
          student_email: this.student_email,
          office_email: this.fbuser,
          send_email_text: this.send_email_text
        }).then((response) => {
          this.preloader = false
          this.response_text = response.data
          this.response_snackbar = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      getBillClient: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/check_bill', {
          token: this.token,
          customer_id: this.preg_customer_id,
          contract_id: this.preg_contract_id,
          teacher: this.student_oktato
        }).then((response) => {
          this.preloader = false
          if (response.data['success'] == false) {
            this.error_message = response.data['message'];
            this.error_dialog = true;
          } else {
            this.savePregStud();
          }
        }, (error) => {
          this.error_text = error.data
        })
      },
      getPalces: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/tanpalyak', {
          token: this.token
        }).then((response) => {
          this.preloader = false
          this.gyak_helyszin = response.data;
        }, (error) => {
          this.error_text = error.data
        })
      },
      goToStudent() {
        this.Diakok_show = false
        this.DiakokDetails_show = true
        this.contract_id = null
        this.customer_id = null
        this.contract_id = this.preg_contract_id
        this.customer_id = this.preg_customer_id
        router.push({ path: 'diakok' })
      },
      resetValidation () {
        this.$refs.oktato_form.resetValidation()
      },
      validate () {
        this.$refs.oktato_form.validate()
      },
    },
    watch: {
      state() {
        this.Teachers()
      },
      prereg_state() {
        this.preregList()
      },
      students_state() {
        this.Students()
      },
      selected_helyszin() {
        this.preregList()
      },
      kapott_oktatot() {
        this.preregList()
      }
    },
    mounted() {
      this.getKAVTeachers()
      this.Teachers()
      this.getCategories()
      //this.getOktHelyszin()
      this.getPregOktatok()
      this.getPalces()
    },
    computed: {
    ...mapFields([
    'showing.preloader',
    'showing.Diakok_show',
    'showing.DiakokDetails_show',
    'diakok_details.contract_id',
    'diakok_details.customer_id',
    'auth.fbuser',
    'auth.admin',
  ]),
  },
  }
</script>

<style lang="css">
</style>
